import { appConfig } from 'config/customization';

export default {
  container: {
    boxSizing: 'border-box',
    height: '100%',
    padding: '30px 0px',
    width: '25%'
  },
  content: {
    alignItems: 'center',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'center',
    width: '100%',
    textAlign: 'center',
    padding: '0px 30px',
    borderRight: `2px ${appConfig.colors.lightGray} solid`
  },
  icon: {
    width: '9vh',
    height: '9vh',
    userSelect: 'none'
  },
  text: {
    width: '100%',
    userSelect: 'none'
  }
};
